import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdExportsSmart_city_compass = z.any()
export type TagsGetMunicipalities_municipalityIdExportsSmart_city_compass = z.infer<typeof tagsGetMunicipalities_municipalityIdExportsSmart_city_compass>

export const descriptionGetMunicipalities_municipalityIdExportsSmart_city_compass = z.any()
export type DescriptionGetMunicipalities_municipalityIdExportsSmart_city_compass = z.infer<typeof descriptionGetMunicipalities_municipalityIdExportsSmart_city_compass>

export const paramsGetMunicipalities_municipalityIdExportsSmart_city_compass = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdExportsSmart_city_compass = z.infer<typeof paramsGetMunicipalities_municipalityIdExportsSmart_city_compass>

export const querystringGetMunicipalities_municipalityIdExportsSmart_city_compass = z.object({ "from": z.string().date(), "to": z.string().date() }).strict()
export type QuerystringGetMunicipalities_municipalityIdExportsSmart_city_compass = z.infer<typeof querystringGetMunicipalities_municipalityIdExportsSmart_city_compass>

export const responseGetMunicipalities_municipalityIdExportsSmart_city_compass = z.any()
export type ResponseGetMunicipalities_municipalityIdExportsSmart_city_compass = z.infer<typeof responseGetMunicipalities_municipalityIdExportsSmart_city_compass>

interface IGetMunicipalities_municipalityIdExportsSmart_city_compass extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdExportsSmart_city_compass,
  description: DescriptionGetMunicipalities_municipalityIdExportsSmart_city_compass,
  params: ParamsGetMunicipalities_municipalityIdExportsSmart_city_compass,
  querystring: QuerystringGetMunicipalities_municipalityIdExportsSmart_city_compass,
  response: ResponseGetMunicipalities_municipalityIdExportsSmart_city_compass
}
export const URL = '/municipalities/:municipalityId/exports/smart-city-compass'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdExportsSmart_city_compass,
    description: descriptionGetMunicipalities_municipalityIdExportsSmart_city_compass,
    params: paramsGetMunicipalities_municipalityIdExportsSmart_city_compass,
    querystring: querystringGetMunicipalities_municipalityIdExportsSmart_city_compass,
    response: responseGetMunicipalities_municipalityIdExportsSmart_city_compass
  }
}
export interface Municipalities_municipalityIdExportsSmart_city_compass extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdExportsSmart_city_compass
}